import { TierIiReportKind } from "generated-graphql/graphql";

export function formatReportKindForDrillDown(
  reportKind: TierIiReportKind | undefined
): string | undefined {
  if (!reportKind) return undefined;
  if (reportKind === TierIiReportKind.Annual) return "Annual|null";
  if (reportKind === TierIiReportKind.Initial) return "Initial Notification Reports";
  if (reportKind === TierIiReportKind.Revision) return "Revision Reports";
  if (reportKind === TierIiReportKind.NewlyNotReporting) return "Newly Not Reporting";
  if (reportKind === TierIiReportKind.Update) return "Update";
  return reportKind;
}
